import PropTypes from 'prop-types'
import { DashboardCustomize } from '@mui/icons-material'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectThemeMode } from '../../Core/Redux/Theme'
import LocalReportSelectionModal from './LocalReportSelectionModal'
import Config from '../../Core/Config'

const AddToLocalReport = ({ style, color, hoverColor, manager }) => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const theme = useSelector(selectThemeMode)
  if (!hoverColor) hoverColor = theme === 'light' ? '#000' : '#fff'

  if (!Config.reports.enableLocalReports) return null

  return (
    <>
      <DashboardCustomize
        style={style}
        color={color}
        sx={{ cursor: 'pointer', '&:hover': { color: hoverColor } }}
        onClick={() => setModalIsOpen(true)}
      />
      {modalIsOpen && (
        <LocalReportSelectionModal
          manager={manager}
          onClose={() => setModalIsOpen(false)}
        />
      )}
    </>
  )
}

AddToLocalReport.defaultProps = {
  style: {},
  color: 'contrastHigh',
}

AddToLocalReport.propTypes = {
  style: PropTypes.object,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  manager: PropTypes.object,
}

export default AddToLocalReport
